<template>
    <div>
        <div class="top_wrapper">
            <div class="text">专利列表</div>
            <div class="num">共{{total}}条专利</div>
        </div>
        <div class="item_wrapper">
            <div :class="{'item': true, 'active': detailInfo.id == item.id}" v-for="(item,index) in result" :key="item.id" @click="goDetail(item.id)">
                <div class="tit">{{index+1}}. &nbsp;&nbsp;{{item.id}}</div>
                <div class="desp">{{item.title}}</div>
            </div>
        </div>
        <div class="item_pagination">
            <v-pagination
                v-model="page"
                :length="length"
                :total-visible="maxLength"
                >
            </v-pagination>
        </div>
    </div>
</template>
<script>
import { mapActions} from 'vuex'
export default {
    props: ['detailInfo'],
    data() {
        return {
            length: 0,
            isLoading: false,
            pageSize: 10,
            page:1,
            total: 0,
            result: [],
            filterq2: '',
            keyValue: '',
            fcKey: '',
            maxLength: 7
        }
    },
    mounted() {
        this.filterq2 = sessionStorage.getItem('secondFilter')
        this.keyValue = this.$store.state.searchKey || sessionStorage.getItem('searchKey')
        this.fcKey = this.$store.state.fcKeyData || sessionStorage.getItem('fcKeyData')
        this.getList()
    },
    watch: {
        page(val) {
            this.getList()
        }
    },
    methods: {
        ...mapActions('search',['querySearch']),
        getList() {
            let country = localStorage.getItem('countries')
            let ds = 'cn'
            if(country) {
                country = JSON.parse(country)
                if(country.length==1) {
                    ds = country[0]
                }else {
                    ds = 'cn'
                }
            }
            let data = {
                params: {
                    fc: this.fcKey,
                    q: this.keyValue,
                    ds: ds,
                    s: 'score!',
                    dm: 'tables',
                    p: this.page,
                    ps: this.pageSize,
                    q2: this.filterq2
                }
            }
            let _this = this
            this.querySearch({data: data, handle(res) {
                _this.isLoading = false
                _this.total = res.pagination.total
                _this.result = res.pagination.data
                _this.length = Math.ceil(_this.total / _this.pageSize)>200?200: Math.ceil(_this.total / _this.pageSize)
            }})
        },
        goDetail(id) {
            this.$emit('detailChange', id)
        }
    }
}
</script>